import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  passwordChangeStateRecoil,
} from '../../atom/ModalAtom';
import { userIdState } from '../../atom/TokenAtom';
import { PasswordChangeDto } from '../../model/user.dto';
import { authAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

const PasswordChange = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const setModalState = useSetRecoilState(passwordChangeStateRecoil);

  const [existingPassword, setExistingPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const handleConfirm = async () => {
    if (
      existingPassword === '' ||
      newPassword === '' ||
      passwordConfirm === ''
    ) {
      setError(blankMsg);
      return;
    }

    if (
      newPassword.length < 8 ||
      !newPassword.match(/^(?=.*[a-zA-Z])(?=.*\d).*$/)
    ) {
      setError('영문과 숫자를 조합하여 8~20자로 입력해 주세요.');
      return;
    }

    if (newPassword !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    if (existingPassword === newPassword) {
      setError('새로운 비밀번호는 이전 비밀번호와 같을 수 없습니다.');
      return;
    }

    try {
      const formData: PasswordChangeDto = {
        oldPassword: existingPassword,
        newPassword: newPassword,
      };
      await authAPI.passwordChange(formData);
      setModalState(false);
      localStorage.clear();
      sessionStorage.clear();
      navigate('/login');
      setConfirm(
        '성공적으로 비밀번호가 수정되었습니다.\n다시 로그인 해주세요.',
      );
    } catch (err: any) {
      if (err.response.data.message === 'Password Not Matched') {
        setError('현재 비밀번호가 일치하지 않습니다.');
      }
    }
  };

  return (
    <>
      <InputModal
        title="비밀번호 변경"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              현재 비밀번호
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="현재 비밀번호 입력"
              type="password"
              value={existingPassword}
              onChange={(e) => setExistingPassword(e.target.value)}
              aria-label="현재 비밀번호 입력 필드"
            />
          </li>
          <li>
            <h2>
              새로운 비밀번호
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="새로운 비밀번호 입력(영문 숫자 조합 8~20자)"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              aria-label="새로운 비밀번호 입력 필드"
            />
          </li>
          <li>
            <h2>
              비밀번호 확인
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="비밀번호 확인 입력"
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              aria-label="비밀번호 확인 입력 필드"
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default PasswordChange;
